import { usePssRestoreAuthRepo } from "../../authentication/repositories/usePssRestoreAuthRepo";

export const usePssLayoutController = () => {
  const {
    state: { loading, isAuthenticated },
  } = usePssRestoreAuthRepo();

  return {
    state: {
      loading,
      isAuthenticated,
    },
  };
};
